import React from 'react';
import LoupeLocalActivities from './LoupeLocalActivities';
import Paper from '@mui/material/Paper';


function LoupeActivityByLocation(props) {

    const language = props.language;
    const availableLanguages = props.availableLanguages;

    return (
        <Paper>    
            <div>
                <LoupeLocalActivities  language={language} availableLanguages={availableLanguages} />
                <p className="mb-6 pageend">&nbsp;</p>
            </div> 
        </Paper>        
    );
}

export default LoupeActivityByLocation;